<template>
<div class="chapter">
<div class="inner_page">
<p class="imaget"><a id="px"></a><span epub:type="pagebreak" id="pagex" title="x"><a id="map1"></a><img alt="illustration" src="images/map1.png"/></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// map1.vue?5e628bee